<template>
  <div class="shop">
    <section class="g-bg-gray-light-v5">
      <div class="container g-py-50">
        <div class="text-center">
          <div class="align-self-center">
            <h2 class="h3 g-font-weight-300 w-100 g-mb-10 g-mb-0--md">智郵易服務地點</h2>
          </div>
        </div>
      </div>
    </section>
    <section class="container g-py-100">
      <post-offices-list />
    </section>
  </div>
</template>

<script>
import PostOfficesList from '../components/PostOfficesList';

export default {
  name: 'Shop',
  components: {
    PostOfficesList,
  },
};
</script>
